import { FormControl, FormLabel, Input, Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface AditionalDetailsOutForm {
    data: any;
    onChange: (data: any) => void;
}

const AditionalDetailsOutForm = (props: AditionalDetailsOutForm) => {
    const {
        data,
        onChange
    } = props;

    const { t } = useTranslation("translations");

    const onEdit = (name: string, value: unknown) => {
        let tmp = { ...data };
        tmp[name] = value;
        onChange(tmp);
    }

    return (
        <>
            <FormControl>
                <FormLabel>{t("BUYER_NAME")}</FormLabel>
                <Input
                    isRequired
                    name="buyerName"
                    placeholder={t("BUYER_NAME")}
                    value={data.buyerName}
                    onChange={(e) => onEdit(e.target.name, e.target.value)}
                />
            </FormControl>

            <FormControl>
                <FormLabel>{t("BUYER_LOCATION")}</FormLabel>
                <Input
                    isRequired
                    name="buyerLocation"
                    placeholder={t("BUYER_LOCATION")}
                    value={data.buyerLocation}
                    onChange={(e) => onEdit(e.target.name, e.target.value)}
                />
            </FormControl>

            <FormControl>
                <FormLabel>{t("BUYER_TYPE")}</FormLabel>
                <Select
                    isRequired
                    name="buyerType"
                    placeholder={t("BUYER_TYPE")}
                    value={data.buyerType}
                    onChange={(e) => onEdit(e.target.name, +e.target.value)}
                >
                    <option value='1'>PJ</option>
                    <option value='0'>PF</option>
                </Select>
            </FormControl>

            {
                data.buyerType && data.buyerType === 1 &&
                <FormControl>
                    <FormLabel>{t("CUI")}</FormLabel>
                    <Input
                        isRequired
                        name="cui"
                        placeholder={t("CUI")}
                        value={data.cui}
                        onChange={(e) => onEdit(e.target.name, e.target.value)}
                    />
                </FormControl>
            }
        </>
    )
}

export default AditionalDetailsOutForm;